/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommNotifBannerViewProps } from './ecomm-notif-banner';

/**
 *
 * EcommContentTemplate1View component
 * @extends {React.PureComponent<IEcommNotifBannerViewProps>}
 */
export class EcommNotifBannerView extends React.PureComponent<IEcommNotifBannerViewProps> {
  public render(): JSX.Element | null {
    const { title, description } = this.props;

    if (window && window.sessionStorage.getItem('hasRead') === 'true') {
      return null;
    }

    return (
      <div className='ecomm-notif-banner row'>
        <h6 className='title col-10 col-sm-8'>{title}</h6>
        <div className='button-close col-2 col-sm-4'><button onClick={this._handleOnClick}/></div>
        <p className='ecomm-notif-banner-editor col-12' id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>{description}</p>
      </div>
    );
  }

  private _handleOnClick = () => {
    if (window !== undefined) {
      window.sessionStorage.setItem('hasRead', 'true');

      this.forceUpdate();
    }
  }
}

export default EcommNotifBannerView;